export default "__VITE_ASSET__CE9PDDVe__"